import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BreadcrumbModel } from '../../../../core/models/misc/breadcrumb.model';
import { ServiceModule } from '../../../service.module';

@Injectable({ providedIn: ServiceModule })
export class HeaderTitleService {
    breadcrumbs: BehaviorSubject<BreadcrumbModel[]> = new BehaviorSubject<BreadcrumbModel[]>([]);

    setTitle(breadcrumbs: BreadcrumbModel[]) {
        this.breadcrumbs.next(breadcrumbs);
    }
}
